import React from 'react';
import { TreeNode as TreeNodeType } from '../../models/TreeModel';
import { DEFAULT_ICON_MAP } from './treeNodeIconMap';
import { ConnectionEngineIcon } from '../../../connections/components/ConnectionEngineIcon';

interface TreeNodeIconProps {
  node: TreeNodeType;
  isExpanded: boolean;
  iconMap: Record<string, React.ElementType>;
}

export function TreeNodeIcon({ node, isExpanded, iconMap }: TreeNodeIconProps) {
  // Special handling for connection nodes - use engine-specific icons
  if (node.type === 'connection' && node.metadata?.engine) {
    return (
      <ConnectionEngineIcon
        engine={node.metadata.engine}
        size="sm"
        iconOnly
        className="shrink-0"
      />
    );
  }

  if (node.icon && iconMap[node.icon]) {
    const IconComponent = iconMap[node.icon];
    return <IconComponent className="h-4 w-4 shrink-0" />;
  }

  if (node.type === 'folder') {
    const FolderIcon = isExpanded
      ? iconMap['folder-open'] || DEFAULT_ICON_MAP['folder-open']
      : iconMap['folder'] || DEFAULT_ICON_MAP['folder'];

    return <FolderIcon className="h-4 w-4 shrink-0" />;
  }

  const IconComponent =
    iconMap[node.type] || iconMap['default'] || DEFAULT_ICON_MAP['default'];
  return <IconComponent className="h-4 w-4 shrink-0" />;
}
